import { OrganisationId } from '../../organisations/entities/organisation.entity';

enum RoleIdBrand {
    _ = ''
}
export type RoleId = string & RoleIdBrand;

export interface Role {
    RoleId: RoleId;
    Label: string;
    OrganisationId: OrganisationId | null;
    Functions: string[];
}

export class RoleClass {
    Id: RoleId;
    Name: string;
    OriginalLabel: string;
    OrganisationId: OrganisationId;
    Functions: string[];

    constructor(role: Role, displayLabel: string) {
        this.Id = role.RoleId;
        this.OrganisationId = role.OrganisationId ?? ('' as OrganisationId);
        this.Name = displayLabel;
        this.OriginalLabel = role.Label;
        this.Functions = role.Functions;
    }
}
